// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"6b881f3a","585":"e9e08fad"}[chunkId] + ".chunk.js";
};